import useLanguage from "./useLanguage";

//
const utils = require("../utils/url.utils");

export default function useUtils() {
  const { language } = useLanguage();

  const isDemo = utils.MODE === "demo";

  const mapStyles = [
    {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#E6E9EC",
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#E6E9EC",
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#556276",
        },
      ],
    },
    {
      featureType: "administrative.neighborhood",
      elementType: "labels.text.fill",
      stylers: [
        {
          lightness: 0,
        },
        {
          color: "#556276",
        },
      ],
    },
    {
      featureType: "landscape.man_made",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#E6E9EC",
        },
      ],
    },
    {
      featureType: "landscape.man_made",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#E6E9EC",
        },
      ],
    },
    {
      featureType: "landscape.natural",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#E6E9EC",
        },
      ],
    },
    {
      featureType: "landscape.natural",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#7492a8",
        },
      ],
    },
    {
      featureType: "landscape.natural.terrain",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#dde2e3",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "labels.icon",
      stylers: [
        {
          saturation: -100,
        },
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#588ca4",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#a9de83",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#bae6a1",
        },
      ],
    },
    {
      featureType: "poi.sports_complex",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#c6e8b3",
        },
      ],
    },
    {
      featureType: "poi.sports_complex",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#bae6a1",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "labels.icon",
      stylers: [
        {
          saturation: -45,
        },
        {
          lightness: 10,
        },
        {
          visibility: "on",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#41626b",
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#ffffff",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#A4B6DB",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#A4B6DB",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "road.highway.controlled_access",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#A4B6DB",
        },
      ],
    },
    {
      featureType: "road.local",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#ffffff",
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "labels.icon",
      stylers: [
        {
          saturation: -70,
        },
      ],
    },
    {
      featureType: "transit.line",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#b4cbd4",
        },
      ],
    },
    {
      featureType: "transit.line",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#588ca4",
        },
      ],
    },
    {
      featureType: "transit.station",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#008cb5",
        },
      ],
    },
    {
      featureType: "transit.station.airport",
      elementType: "geometry.fill",
      stylers: [
        {
          saturation: -100,
        },
        {
          lightness: -5,
        },
      ],
    },
    {
      featureType: "water",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#ADD5F4",
        },
      ],
    },
  ];

  const darkModeMapStyles = [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "poi",
      stylers: [{ visibility: "off" }], // Hide all POIs by default
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#263c3f", visibility: "on" }], // Only show park areas
    },
    {
      featureType: "poi.park",
      elementType: "labels.text",
      stylers: [{ visibility: "off" }], // Hide park labels
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#38414e" }],
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{ color: "#212a37" }],
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9ca5b3" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#746855" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#1f2835" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#f3d19c" }],
    },
    {
      featureType: "transit",
      stylers: [{ visibility: "off" }], // Hide transit stations
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#17263c" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#515c6d" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#17263c" }],
    },
    {
      featureType: "poi.business",
      stylers: [{ visibility: "off" }], // Hide business POIs
    },
    {
      featureType: "poi.government",
      stylers: [{ visibility: "off" }], // Hide government POIs
    },
    {
      featureType: "poi.medical",
      stylers: [{ visibility: "off" }], // Hide medical POIs
    },
    {
      featureType: "poi.place_of_worship",
      stylers: [{ visibility: "off" }], // Hide places of worship
    },
    {
      featureType: "poi.school",
      stylers: [{ visibility: "off" }], // Hide schools
    },
    {
      featureType: "poi.attraction",
      stylers: [{ visibility: "off" }], // Hide attractions
    },
  ];

  const formatTimeFromSeconds = (totalSeconds) => {
    if (totalSeconds === 0) return `1 ${language.MIN_SHORT}`;
    if (isNaN(totalSeconds) || totalSeconds < 0) return "Invalid time";

    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);

    // Helper function to format unit with correct singular/plural
    const formatUnit = (value, unit, units) => {
      if (value === 0) return "";
      return `${value} ${value === 1 ? unit : units}`;
    };

    // Format the time based on which units are needed
    let formattedTime = "";

    if (days > 0) {
      formattedTime += formatUnit(days, language.DAY, language.DAYS);
      // If days are present, only show hours as the secondary unit
      if (hours > 0) {
        formattedTime += ` ${formatUnit(hours, language.HOUR_SHORT, language.HOURS_SHORT)}`;
      }
    } else if (hours > 0) {
      formattedTime += formatUnit(
        hours,
        language.HOUR_SHORT,
        language.HOURS_SHORT,
      );
      // If hours are present, only show minutes as the secondary unit
      if (minutes > 0) {
        formattedTime += ` ${formatUnit(minutes, language.MIN_SHORT, language.MINS_SHORT)}`;
      }
    } else if (minutes > 0) {
      formattedTime += formatUnit(
        minutes,
        language.MIN_SHORT,
        language.MINS_SHORT,
      );
    } else {
      formattedTime = formatUnit(seconds, language.SECONDS, language.SECONDS);
    }

    return formattedTime.trim();
  };

  const calculateDistanceUnit = (unit, distanceUnit) => {
    if (distanceUnit === "KM") {
      return `${(unit / 1000)?.toFixed(2)} ${language.KM}`;
    } else if (distanceUnit === "MILES") {
      return `${(unit / 1609)?.toFixed(2)} ${language.MILES}`;
    } else {
      return `${0} ${language.KM}`;
    }
  };

  const morph = (text = "", force = false) => {
    // if empty or null → return as is
    if (!text) return "";

    // convert always to string
    const str = text.toString();

    // Mask only in demo mode
    if (utils.HOST === "demo" || force) {
      // If length <= 2 mask completely
      if (str.length <= 2) {
        return "*".repeat(str.length);
      }

      // Mask everything except first 2 characters
      const masked = str.slice(0, 2) + "*".repeat(str.length - 2);

      // Optional: limit visible length (looks neat in tables)
      return masked.length > 12 ? masked.slice(0, 12) : masked;
    } else {
      return str;
    }
  };

  return {
    formatTimeFromSeconds,
    mapStyles,
    darkModeMapStyles,
    isDemo,
    calculateDistanceUnit,
    morph,
  };
}
